const CACHE_LIMIT = 32;
const maskCache = new Map();

export const getMaskCache = (key) => maskCache.get(key);

export const setMaskCache = (key, value) => {
  if (!key || !value) return;
  maskCache.set(key, value);
  if (maskCache.size > CACHE_LIMIT) {
    const firstKey = maskCache.keys().next().value;
    maskCache.delete(firstKey);
  }
};

export const clearMaskCache = () => {
  maskCache.clear();
};
